export class Document {
    public id: number ;
    public name: string;
    public structure: any;
}

    
